export default function useCustomParseInt(value: unknown) {
  if (typeof value === 'string') return parseInt(value, 10);

  return value as number;
}
